import { User, useCoreApi, useUserData } from '@givebacks/api/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';

type Extensions = 'Chrome' | 'Safari';
export function useUpdateExtensionStatus() {
  const { data: uuid } = useUserData((user: User) => user.uuid);
  const CoreApi = useCoreApi();
  const queryClient = useQueryClient();

  const updateStatus = async ({ platform, status }: { platform: Extensions; status: boolean }) => {
    if (!uuid) return false;
    const { data } = await CoreApi.post('/settings/extensions', {
      setting: { key: platform, boolean: status, user_id: uuid },
    });
    return data;
  };

  return useMutation({
    mutationFn: updateStatus,
    onSuccess() {
      void queryClient.invalidateQueries({ queryKey: ['user'] });
    },
  });
}
function useSendEmailConfirmation() {
  const CoreApi = useCoreApi();

  const confirmEmail = async (email: string) => {
    const { data } = await CoreApi.post(`/users/confirmation`, { user: { email } });
    return data;
  };

  return useMutation({
    mutationFn: confirmEmail,
  });
}

export { useSendEmailConfirmation };
